import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// helpers
import get from 'lodash.get';

function PdpSharedDetailProductionType({ item }) {
    return (
        <span data-tn="pdp-spec-production-type">
            {get(item, 'attributes.productionType[0].option.name')}
        </span>
    );
}

PdpSharedDetailProductionType.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailProductionType, {
    item: graphql`
        fragment PdpSharedDetailProductionType_item on Item {
            attributes {
                productionType {
                    option {
                        name
                    }
                }
            }
        }
    `,
});
